import { render, staticRenderFns } from "./tsCashGift.vue?vue&type=template&id=5f1d6f00&scoped=true"
import script from "./tsCashGift.vue?vue&type=script&lang=js"
export * from "./tsCashGift.vue?vue&type=script&lang=js"
import style0 from "./tsCashGift.vue?vue&type=style&index=0&id=5f1d6f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d6f00",
  null
  
)

export default component.exports